import { render, staticRenderFns } from "./TruckPopup.vue?vue&type=template&id=19068a0a&scoped=true&"
import script from "./TruckPopup.vue?vue&type=script&lang=js&"
export * from "./TruckPopup.vue?vue&type=script&lang=js&"
import style0 from "./TruckPopup.vue?vue&type=style&index=0&id=19068a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19068a0a",
  null
  
)

export default component.exports